import {
  API_ERROR,
  CATEGORY,
  CATEGORY_LIST_SUCCESSFUL,
  CATEGORY_ADD,
  CATEGORY_ADD_SUCCESSFUL,
  CATEGORY_EDIT,
  CATEGORY_EDIT_SUCCESSFUL,
  CATEGORY_DELETE,
  CATEGORY_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  Categorylist: [],
  model: false,
  error_msg: null,
  rowdata: {},
};

const Category = (state = initialState, action) => {
  switch (action.type) {
    case CATEGORY:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CATEGORY_LIST_SUCCESSFUL:
      state = {
        ...state,
        Categorylist: action.payload.response.results,
        loading: false,
      };
      break;
    case CATEGORY_ADD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case CATEGORY_ADD_SUCCESSFUL:
      state = {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {Id:0},
      };
      break;
    case CATEGORY_EDIT:
      state = {
        ...state,
        model: true,
        rowdata: action.payload,
      };
      break;
    case CATEGORY_EDIT_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        rowdata: {Id:0},
      };
      break;
    case CATEGORY_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case CATEGORY_SETROWDATA:
      state = {
        ...state,
        rowdata: action.payload,
        // model: true,
      };
      break;
    case MODEL_OPEN:
      state = {
        ...state,
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        model: false,
        rowdata: { id: 0 },
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Category;
